// extracted by mini-css-extract-plugin
export default {"container":"IBgVd","srOnly":"NLF9q"};